/* eslint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetSimilarOffersRequest, TGetSimilarOffersModel, IMappers, TGetSimilarOffersResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRecommendedOffersResponseSchema } from '../../entities/recommended_offers/GetRecommendedOffersResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSimilarOffersModel(parameters: TGetSimilarOffersRequest): TGetSimilarOffersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-engine',
    pathApi: '/v3/get-similar-offers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetSimilarOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetSimilarOffersRequest;
}

export async function fetchGetSimilarOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSimilarOffersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSimilarOffersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSimilarOffersModel(parameters),
    config,
  )) as FetchResponse<TGetSimilarOffersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRecommendedOffersResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSimilarOffersResponse>;
}
